// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import HeroSection from "../../layout/HeroSection";
// import Loader from "../../components/other/Loader";
// import { pageRoutes } from "../../routes/pageRoutes";
// import { useDispatch, useSelector } from "react-redux";
// import NoRecord from "../../components/other/NoRecord";
// import { fetchEmbeds } from "../../redux/action/embedActions";
// const Lexicon = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [searchTerm, setSearchTerm] = useState("");
//   const { isLoading, embedList } = useSelector((state) => state.embedReducer);

//   const filteredLexicon = embedList?.lexicon?.filter((item) =>
//     searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
//   );

//   const filteredWeightClasses = embedList?.weight_classes?.filter((item) =>
//     searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
//   );

//   const filteredVendors = embedList?.vendors?.filter((item) =>
//     searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
//   );
//   const filteredYoutubeChannels = embedList?.youtube_channels?.filter((item) =>
//     searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
//   );
//   const filteredNotableCommunityMembers =
//     embedList?.notable_community_members?.filter((item) =>
//       searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
//     );

//   useEffect(() => {
//     dispatch(fetchEmbeds());
//   }, []);

//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value.toLowerCase());
//   };

//   if (isLoading) {
//     return <Loader />;
//   }

//   return (
//     <div>
//       <Header />
//       <HeroSection
//         label={<h1 class="mb-3">{"Knowledgebase"}</h1>}
//       // breadcrumbItems={[
//       //   { name: "Home", path: `${pageRoutes?.home}` },
//       //   {
//       //     name: "Knowledgebase",
//       //     path: `${pageRoutes?.home}`,
//       //   },
//       // ]}
//       // banner_image={aboutData?.about_banner}
//       />

//       <section className="untree_co-section pt-5 pb-5 ">
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12">
//               {/* <h2 class="section-title mb-5 text-center">
//                 <strong>Knowledgebase</strong>
//               </h2> */}

//               <div className="ct_search_keyword_input_main">
//                 <p className="mb-0 ct_ff_orbitron">Search by keyword:</p>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={searchTerm}
//                   onChange={handleSearch}
//                 />
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-md-12 mx-auto">
//               <div className="ct_grid_temp_5 ">
//                 <div className="">
//                   <div className="ct_lexicon_links">
//                     <h4 className="text-dark ct_ff_orbitron ct_fs_20">Lexicon</h4>
//                     <p className="mb-0">(Browse by Title)</p>
//                     <ul>
//                       {/* {filteredLexicon?.length > 0 ? (
//                         filteredLexicon?.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={() =>
//                                 navigate(pageRoutes.testing, {
//                                   state: { data: item },
//                                 })
//                               }
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className={"text-start"} />
//                       )} */}
//                       {filteredLexicon?.length > 0 ? (
//                         filteredLexicon.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={(e) => {
//                                 e.preventDefault();

//                                 const url = `${window.location.origin}${pageRoutes.testing}`;

//                                 window.open(url, "_blank", "noopener,noreferrer");

//                                 // OPTIONAL: store data in sessionStorage for new tab
//                                 sessionStorage.setItem(
//                                   "testing_data",
//                                   JSON.stringify(item)
//                                 );
//                               }}
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className="text-start" />
//                       )}

//                     </ul>
//                   </div>
//                 </div>
//                 <div className="">
//                   <div className="ct_lexicon_links">
//                     <h4 className="text-dark ct_ff_orbitron ct_fs_20">Weight Classes</h4>
//                     <p className="mb-0">(Browse by Title)</p>
//                     <ul>
//                       {filteredWeightClasses?.length > 0 ? (
//                         filteredWeightClasses?.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={() =>
//                                 navigate(pageRoutes.testing, {
//                                   state: { data: item },
//                                 })
//                               }
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className={"text-start"} />
//                       )}
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="">
//                   <div className="ct_lexicon_links">
//                     <h4 className="text-dark ct_ff_orbitron ct_fs_20">Vendors</h4>
//                     <p className="mb-0">(Browse by Title)</p>
//                     <ul>
//                       {filteredVendors?.length > 0 ? (
//                         filteredVendors?.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={() =>
//                                 navigate(pageRoutes.testing, {
//                                   state: { data: item },
//                                 })
//                               }
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className={"text-start"} />
//                       )}
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="">
//                   <div className="ct_lexicon_links">
//                     <h4 className="text-dark ct_ff_orbitron ct_fs_20">
//                       YouTube Channels
//                     </h4>
//                     <p className="mb-0">(Browse by Title)</p>
//                     <ul>
//                       {filteredYoutubeChannels?.length > 0 ? (
//                         filteredYoutubeChannels?.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={() =>
//                                 navigate(pageRoutes.testing, {
//                                   state: { data: item },
//                                 })
//                               }
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className={"text-start"} />
//                       )}
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="">
//                   <div className="ct_lexicon_links">
//                     <h4 className="text-dark ct_ff_orbitron ct_fs_20">
//                       Notable Community Members
//                     </h4>
//                     <p className="mb-0">(Browse by Title)</p>
//                     <ul>
//                       {filteredNotableCommunityMembers?.length > 0 ? (
//                         filteredNotableCommunityMembers?.map((item, index) => (
//                           <li key={index}>
//                             <a
//                               href="javascript:void(0)"
//                               onClick={() =>
//                                 navigate(pageRoutes.testing, {
//                                   state: { data: item },
//                                 })
//                               }
//                             >
//                               {item.title}
//                             </a>
//                           </li>
//                         ))
//                       ) : (
//                         <NoRecord className={"text-start"} />
//                       )}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default Lexicon;

//----------------OLD Code___________END

// ============ Lexicon.jsx ============
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { fetchEmbeds } from "../../redux/action/embedActions";

const Lexicon = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoading, embedList } = useSelector((state) => state.embedReducer);

  const filteredLexicon = embedList?.lexicon?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item,
  );

  const filteredWeightClasses = embedList?.weight_classes?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item,
  );

  const filteredVendors = embedList?.vendors?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item,
  );

  const filteredYoutubeChannels = embedList?.youtube_channel?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item,
  );

  const filteredNotableCommunityMembers =
    embedList?.notable_community_members?.filter((item) =>
      searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item,
    );

  useEffect(() => {
    dispatch(fetchEmbeds());
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const isGoogleDoc = (url = "") => {
    return url.includes("docs.google.com") || url.includes("drive.google.com");
  };

  // // Function to handle opening items in new tab with URL parameters
  // const handleOpenInNewTab = (item) => {
  //   // Encode the data as base64 to pass in URL
  //   const encodedData = btoa(JSON.stringify(item));
  //   const url = `${window.location.origin}${pageRoutes.testing}?data=${encodedData}`;
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  const handleOpenInNewTab = (item) => {
    const link = item.embed_link;

    if (!link) return;

    // Google Docs → internal viewer
    if (isGoogleDoc(link)) {
      const encodedData = btoa(JSON.stringify(item));
      const url = `${window.location.origin}${pageRoutes.testing}?data=${encodedData}`;
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    // External website → direct open
    window.open(link, "_blank", "noopener,noreferrer");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header />
      <HeroSection label={<h1 className="mb-3">{"Knowledgebase"}</h1>} />

      <section className="untree_co-section pt-5 pb-5 ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ct_search_keyword_input_main">
                <p className="mb-0 ct_ff_orbitron">Search by keyword:</p>
                <input
                  type="text"
                  className="form-control"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mx-auto">
              <div className="ct_grid_temp_5 ">
                {/* Lexicon Section */}
                <div className="">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron ct_fs_20">
                      Lexicon
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredLexicon?.length > 0 ? (
                        filteredLexicon.map((item, index) => (
                          // <li key={index}>
                          //   <a
                          //     href="javascript:void(0)"
                          //     onClick={(e) => {
                          //       e.preventDefault();
                          //       handleOpenInNewTab(item);
                          //     }}
                          //   >
                          //     {item.title}
                          //   </a>
                          // </li>
                          <li
                            key={index}
                            style={{ listStyle: "none", marginBottom: "10px" }}
                          >
                            <a
                              href={
                                item.type == "link"
                                  ? item.link
                                  : "javascript:void(0)"
                              }
                              target={item.type == "link" ? "_blank" : "_self"}
                              onClick={(e) => {
                                if (item.type != "link") {
                                  e.preventDefault();
                                  handleOpenInNewTab(item);
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                textDecoration: "none",
                                color: "#000",
                              }}
                            >
                              {/* Thumbnail / Placeholder */}
                              {item.image ? (
                                <img
                                  src={`https://robotcombat101.com/admin/public/cms_images/${item.image}`}
                                  alt={item.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}

                              {/* Dynamic Letter Placeholder */}
                              <div
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  background: "#6f42c1", // purple
                                  color: "#fff",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                  flexShrink: 0,
                                }}
                              >
                                {item.title?.charAt(0) || "?"}
                              </div>

                              {/* Title */}
                              <span>{item.title}</span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className="text-start" />
                      )}
                    </ul>
                  </div>
                </div>

                {/* Weight Classes Section */}
                <div className="">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron ct_fs_20">
                      Weight Classes
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredWeightClasses?.length > 0 ? (
                        filteredWeightClasses.map((item, index) => (
                          <li
                            key={index}
                            style={{ listStyle: "none", marginBottom: "10px" }}
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenInNewTab(item);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                textDecoration: "none",
                                color: "#000",
                              }}
                            >
                              {/* Thumbnail / Placeholder */}
                              {item.image ? (
                                <img
                                  src={`https://robotcombat101.com/admin/public/cms_images/${item.image}`}
                                  alt={item.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}

                              {/* Dynamic Letter Placeholder */}
                              <div
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  background: "#6f42c1", // purple
                                  color: "#fff",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                  flexShrink: 0,
                                }}
                              >
                                {item.title?.charAt(0) || "?"}
                              </div>

                              {/* Title */}
                              <span>{item.title}</span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className="text-start" />
                      )}
                    </ul>
                  </div>
                </div>

                {/* Vendors Section */}
                <div className="">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron ct_fs_20">
                      Vendors
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredVendors?.length > 0 ? (
                        filteredVendors.map((item, index) => (
                          // <li key={index}>
                          //   <a
                          //     href="javascript:void(0)"
                          //     onClick={(e) => {
                          //       e.preventDefault();
                          //       handleOpenInNewTab(item);
                          //     }}
                          //   >
                          //     {item.title}
                          //   </a>
                          // </li>
                          <li
                            key={index}
                            style={{ listStyle: "none", marginBottom: "10px" }}
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenInNewTab(item);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                textDecoration: "none",
                                color: "#000",
                              }}
                            >
                              {/* Thumbnail / Placeholder */}
                              {item.image ? (
                                <img
                                  src={`https://robotcombat101.com/admin/public/cms_images/${item.image}`}
                                  alt={item.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}

                              {/* Dynamic Letter Placeholder */}
                              <div
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  background: "#6f42c1", // purple
                                  color: "#fff",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                  flexShrink: 0,
                                }}
                              >
                                {item.title?.charAt(0) || "?"}
                              </div>

                              {/* Title */}
                              <span>{item.title}</span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className="text-start" />
                      )}
                    </ul>
                  </div>
                </div>

                {/* YouTube Channels Section */}
                <div className="">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron ct_fs_20">
                      YouTube Channels
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredYoutubeChannels?.length > 0 ? (
                        filteredYoutubeChannels.map((item, index) => (
                          // <li key={index}>
                          //   <a
                          //     href="javascript:void(0)"
                          //     onClick={(e) => {
                          //       e.preventDefault();
                          //       handleOpenInNewTab(item);
                          //     }}
                          //   >
                          //     {item.title}
                          //   </a>
                          // </li>
                          <li
                            key={index}
                            style={{ listStyle: "none", marginBottom: "10px" }}
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenInNewTab(item);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                textDecoration: "none",
                                color: "#000",
                              }}
                            >
                              {/* Thumbnail / Placeholder */}
                              {item.image ? (
                                <img
                                  src={`https://robotcombat101.com/admin/public/cms_images/${item.image}`}
                                  alt={item.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}

                              {/* Dynamic Letter Placeholder */}
                              <div
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  background: "#6f42c1", // purple
                                  color: "#fff",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                  flexShrink: 0,
                                }}
                              >
                                {item.title?.charAt(0) || "?"}
                              </div>

                              {/* Title */}
                              <span>{item.title}</span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className="text-start" />
                      )}
                    </ul>
                  </div>
                </div>

                {/* Notable Community Members Section */}
                <div className="">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron ct_fs_20">
                      Notable Community Members
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredNotableCommunityMembers?.length > 0 ? (
                        filteredNotableCommunityMembers.map((item, index) => (
                          // <li key={index}>
                          //   <a
                          //     href="javascript:void(0)"
                          //     onClick={(e) => {
                          //       e.preventDefault();
                          //       handleOpenInNewTab(item);
                          //     }}
                          //   >
                          //     {item.title}
                          //   </a>
                          // </li>
                          <li
                            key={index}
                            style={{ listStyle: "none", marginBottom: "10px" }}
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenInNewTab(item);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                textDecoration: "none",
                                color: "#000",
                              }}
                            >
                              {/* Thumbnail / Placeholder */}
                              {item.image ? (
                                <img
                                  src={`https://robotcombat101.com/admin/public/cms_images/${item.image}`}
                                  alt={item.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}

                              {/* Dynamic Letter Placeholder */}
                              <div
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  background: "#6f42c1", // purple
                                  color: "#fff",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                  flexShrink: 0,
                                }}
                              >
                                {item.title?.charAt(0) || "?"}
                              </div>

                              {/* Title */}
                              <span>{item.title}</span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className="text-start" />
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Lexicon;
